import { QueryFunctionContext } from '@tanstack/react-query';
import { UsePlayerStatisticsQueryKeyProps } from './props';
import baseAPI from '@/api';
import { PlayerWithStats } from '@/models/player/with-stats';

export async function fetchPlayerWithStats({
  queryKey,
}: QueryFunctionContext<UsePlayerStatisticsQueryKeyProps>): Promise<PlayerWithStats> {
  const { slug } = queryKey[1];

  const response = await baseAPI.get<PlayerWithStats>('/players/statistics', {
    params: {
      slug,
    },
  });

  return response.data;
}
